/**
 * PCI Compliance site seal (Rapid Scan Secure / Aperia).
 *
 * The vendor's script relies on legacy document.write() which browsers block
 * when loaded asynchronously. We host a tiny static HTML file at
 * /pci-seal.html that loads the vendor script during initial page parse
 * (where document.write works) and embed that file via an iframe here.
 */
export default function PciSeal() {
  return (
    <iframe
      src="/pci-seal.html"
      title="PCI DSS Compliant — verified by Rapid Scan Secure"
      data-testid="pci-compliance-seal"
      loading="lazy"
      className="border-0 opacity-80 hover:opacity-100 transition-opacity"
      style={{
        width: "115px",
        height: "58px",
        background: "transparent",
        colorScheme: "normal",
      }}
    />
  );
}
